module.exports = __webpack_public_path__ + "static/media/more-all-products-3.d91c9206.png";